import styled from 'styled-components';

export const SaveDialogStyled = styled.div`
  width: 100%;
  height: 100%;
  background-color: #00000040;
  pointer-events: all;
  position: relative;

  display: grid;
  justify-items: center;
  align-items: center;

  > div {
    width: 75%;
    height: 75%;

    min-width: 800px;
    min-height: 500px;
    background-color: #333333;
    border-radius: 25px;
    padding: 20px;

    display: flex;
    flex-flow: row;
    overflow: hidden;
  }
`;

export const SDPreviewStyled = styled.div`
  height: 100%;
  flex: 1;
  position: relative;

  display: grid;
  justify-items: center;
  align-items: center;

  #Cutout {
    position: absolute;
    background-color: transparent;
    border: 4px solid #888888;
    pointer-events: none;
  }
  #Cutout:before {
    content: " ";
    position: absolute;
    left: -10000px;
    top: -10000px;
    right: -10000px;
    bottom: -10000px;
    border: 10000px solid #00000080;
  }
  svg {
    pointer-events: all;
  }
`;

export const SDUIStyled = styled.div`
  height: 100%;
  flex: 1;
  min-width: 600px;
  max-width: 800px;
  display: flex;
  flex-flow: column;
  padding: 0px 10px;

  > .Buttons {
    display: flex;
    flex-flow: row;
    > button {
      flex: 1;
      margin: 5px;
    }
  }

  > span {
    text-align: center;
    font-size: 16px;
  }
`;

export const SDSaveBlockStyled = styled.div`
  width: calc(100% - 40px);
  padding: 20px 10px;
  margin: 20px 10px;
  flex: 1;
  border-radius: 20px;
  border: 1px solid black;
  position: relative;

  display: grid;
  grid-template-columns: 150px auto 80px;
  grid-column-gap: 5px;
  grid-row-gap: 15px;
  align-content: center;

  > .Selector {
    background-color: #333333;
    position: absolute;
    top: -22px;
    left: 28px;
    display: flex;
    flex-flow: row;
    padding: 5px;
    font-size: 25px;
    align-items: center;
    > label {
      margin: 5px;
    }
  }

  > input[type=range] {
    grid-column-start: 2;
    grid-column-end: 4;
  }
`;

export const SDLoader = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;

  border: 16px solid #555555;
  border-top: 16px solid #156EAC; 
  border-bottom: 16px solid #156EAC; 
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;

  @keyframes spin {
    0% { transform: translate(-50%, -50%) rotate(0deg); }
    100% { transform: translate(-50%, -50%) rotate(360deg); }
  }

`;